if (!customElements.get('dl-js-slide')) {
  class DL_Slide extends HTMLElement {
    constructor() {
      super();
      this.load = false;
      this.flg = null;
      this._ctrlMade = false;        // ★ 追加：コントローラ作成済みフラグ
      this._initialized = false;     // ★ 追加：初期化フラグ

      this.init();
      this.makeCtrl();               // ★ 一度だけ作る（中でガード）
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResize.bind(this));
      this.onScroll();
      this.update();
      this._initialized = true;
    }

    init() {
      if (!this.load) {
        this.li = this.querySelectorAll(".dl-js-slide__li");
        this.num = this.li.length;
        this.idx = 0;
        this.timer = null;
        this.load = true;
        this.interval = this.getAttribute("data-interval") ? this.getAttribute("data-interval") : 6000;

        // ★ ここで一度だけ読み取り、以降はこのフラグを使う
        this.dotsFlg  = this.getAttribute("data-dots")  ? JSON.parse(this.getAttribute("data-dots"))  : false;
        this.arrowFlg = this.getAttribute("data-arrow") ? JSON.parse(this.getAttribute("data-arrow")) : false;
      }
      this.borderLine = window.innerHeight;
      this.top = DL_offsetTop(this);
      this.height = this.offsetHeight;
    }

    update() {
      // ★ タイマーの多重起動防止
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      const slide = this;
      DL_removeClass(slide.li, "is-active");
      DL_addClass(slide.li[slide.idx], "is-active");

      if (slide.dotsFlg && slide.dots && slide.dots.length) {
        DL_removeClass(slide.dots, "is-active");
        DL_addClass(slide.dots[slide.idx], "is-active");
      }
      slide.timer = setTimeout(function() {
        clearTimeout(slide.timer);
        slide.timer = null;
        slide.moveNext();
      }, slide.interval);
    }

    moveNext() { this.idx = (this.idx < this.num - 1) ? this.idx + 1 : 0; this.update(); }
    movePrev() { this.idx = (this.idx > 0) ? this.idx - 1 : this.num - 1; this.update(); }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const _flg = this.flg;
      if (scrollTop + this.borderLine >= this.top) {
        this.flg = !(scrollTop >= this.top + this.height);
      } else {
        this.flg = false;
      }
      if (_flg != this.flg) {
        if (this.flg) {
          this.update();
          DL_addClass(this, "is-active");
        } else {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          DL_removeClass(this, "is-active");
        }
      }
    }

    onResize() { this.init(); }

    makeCtrl() {
      // ★ 既に作っていたら何もしない（重複防止）
      if (this._ctrlMade) return;
      if (this.querySelector('.dl-js-slide__ctrl')) { // ★ HTMLに置いてある場合も重複させない
        this._ctrlMade = true;
        return;
      }

      if (!(this.dotsFlg || this.arrowFlg)) return;

      const html  = document.createElement("div");
      DL_addClass(html, "dl-js-slide__ctrl");
      const inner = document.createElement("div");
      DL_addClass(inner, "dl-js-slide__ctrl__wrap");

      if (this.arrowFlg) {
        const arrow_prev = document.createElement("button");
        DL_addClass(arrow_prev, "dl-js-slide__arrow", "prev");
        arrow_prev.textContent = "PREV";
        inner.appendChild(arrow_prev);
      }

      if (this.dotsFlg) {  // ★ 再JSON.parseせずフラグを使う
        const ul = document.createElement("ul");
        DL_addClass(ul, "dl-js-slide__dots");
        for (let l = 0; l < this.num; l++) {
          const li = document.createElement("li");
          const button = document.createElement("button");
          button.textContent = l + 1;
          li.appendChild(button);
          ul.appendChild(li);
        }
        inner.appendChild(ul);
      }

      if (this.arrowFlg) {
        const arrow_next = document.createElement("button");
        DL_addClass(arrow_next, ["dl-js-slide__arrow", "next"]);
        arrow_next.textContent = "NEXT";
        inner.appendChild(arrow_next);
      }

      html.appendChild(inner);
      this.appendChild(html);

      const slide = this;

      // ★ NodeListの有無は length で判定
      slide.arrow = slide.querySelectorAll(".dl-js-slide__arrow");
      if (slide.arrow.length) {
        for (let i = 0; i < slide.arrow.length; i++) {
          slide.arrow[i].addEventListener("click", function() {
            if (slide.timer) { clearTimeout(slide.timer); slide.timer = null; }
            if (DL_hasClass(this, "next")) { slide.moveNext(); } else { slide.movePrev(); }
          }, false);
        }
      }

      slide.dots = slide.querySelectorAll(".dl-js-slide__dots li");
      if (slide.dots.length) {
        for (let i = 0; i < slide.dots.length; i++) {
          slide.dots[i].setAttribute("data-index", i);
          slide.dots[i].addEventListener("click", function() {
            if (!DL_hasClass(this, "is-active")) {
              if (slide.timer) { clearTimeout(slide.timer); slide.timer = null; }
              slide.idx = parseInt(this.getAttribute("data-index"), 10);
              slide.update();
            }
          }, false);
        }
      }

      this._ctrlMade = true;  // ★ 作成完了フラグ
    }
  }
  customElements.define('dl-js-slide', DL_Slide);
}